import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-arrow-icon/jb-arrow-icon.css.ts
var jb_arrow_icon_css_default = i`svg{align-items:center;block-size:32px;display:flex;fill:var(--stroke-color, #141e55);transition:transform .3s,opacity .3s}svg:hover:not(.disabled){cursor:pointer;transform:translateX(3px)}.left{transform:scale(-1, 1)}.left:hover:not(.disabled){transform:scale(-1, 1) translateX(3px)}.disabled,.swiper-button-disabled{opacity:.2}`;

export {
  jb_arrow_icon_css_default
};
